import { render } from "./index.vue?vue&type=template&id=667896c2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=667896c2&lang=less&scoped=true"

import exportComponent from "D:\\workspace\\forome\\site-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-667896c2"]])

export default __exports__